import React, { useState } from 'react';
import { Button } from 'antd';
import { PlusOutlined, CarOutlined } from '@ant-design/icons';
import VehicleCreateModal from './VehicleCreateModal';

const CreateVehicleButton = ({ onVehicleCreated }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleCreate = (newVehicle) => {
    // Pass the newly created vehicle data to the parent component
    if (onVehicleCreated) {
      onVehicleCreated(newVehicle);
    }
  };

  return (
    <>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={showModal}
        className="flex items-center bg-indigo-600 hover:bg-indigo-700 border-0"
      >
        <CarOutlined className="mr-1" />
        Nouveau Véhicule
      </Button>
      
      <VehicleCreateModal
        visible={modalVisible}
        onCancel={handleCancel}
        onCreateVehicle={handleCreate}
      />
    </>
  );
};

export default CreateVehicleButton;
